import React from "react"
import HowCopiaWorks from "../HowCopiaWorks/how-copia-works.component"
import NonprofitBanner from "../NonprofitBanner/nonprofit-banner.component"
import Testimonials from "../Testimonials/testimonials.component"

import * as S from "./nonprofit-group.styles"

const NonprofitGroup = ({
  backgroundImage,
  howCopiaWorks,
  nonprofitBanner,
  testimonials,
}) => {
  return (
    <S.Section>
      <S.BackgroundImage img={backgroundImage}>
        <S.GroupContainer>
          <HowCopiaWorks {...howCopiaWorks} />
          <NonprofitBanner {...nonprofitBanner} />
          <Testimonials {...testimonials} />
        </S.GroupContainer>
      </S.BackgroundImage>
    </S.Section>
  )
}

export default NonprofitGroup
